import { createDomain } from 'effector'

export const domain = createDomain('filtered games list')
